import React from 'react';
import PropTypes from 'prop-types';

import {Stack} from 'views/components';
import {Translate} from 'views/module';

const CaregiverEditName = (props) => {
  const {
    oldData,
    newData,
  } = props;

  const oldCaregiverName = oldData.caregiverName;
  const newCaregiverName = newData.caregiverName;

  return (
    <Stack>
      <Translate
        expression='caregiver.CaregiverDetail.Correspondance.Logs.EditName.Text'
        substitute={{
          oldCaregiverName,
          newCaregiverName,
        }}
      />
    </Stack>
  );
};
CaregiverEditName.propTypes = {
  oldData: PropTypes.object.isRequired,
  newData: PropTypes.object.isRequired,
};

export default React.memo(CaregiverEditName);
